import { render, staticRenderFns } from "./buyitem.vue?vue&type=template&id=0c6c7fe0&scoped=true"
import script from "./buyitem.vue?vue&type=script&lang=js"
export * from "./buyitem.vue?vue&type=script&lang=js"
import style0 from "./buyitem.vue?vue&type=style&index=0&id=0c6c7fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6c7fe0",
  null
  
)

export default component.exports